import { SupplierEventQuestion } from './types';

type SupplierEventQuestionValueMap = Record<string, unknown>;

export const getSupplierEventQuestionFieldName = (index: number) => `question_${index}`;

export const mapSupplierEventQuestionAnswers = <
  TQuestion extends Pick<SupplierEventQuestion, 'id' | 'text'>,
>(
  questions: TQuestion[] = [],
  values: SupplierEventQuestionValueMap,
): Array<{ questionId: TQuestion['id']; question: string; answer: string }> =>
  questions
    .map((question, index) => {
      const value = values[getSupplierEventQuestionFieldName(index)];

      if (typeof value !== 'string') {
        return null;
      }

      const trimmedAnswer = value.trim();

      if (!trimmedAnswer) {
        return null;
      }

      return {
        questionId: question.id,
        question: question.text,
        answer: trimmedAnswer,
      };
    })
    .filter(
      (
        item,
      ): item is {
        questionId: TQuestion['id'];
        question: string;
        answer: string;
      } => Boolean(item),
    );
